(function($) {
  $('.about-history-slider').slick({
    // autoplay: true,
    // pauseOnHover: true,
    infinite: false,
    variableWidth: true,
    swipeToSlide: true,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    // responsive: [
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       variableWidth: false,
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     }
    //     // settings: "unslick"
    //   },
    // ]
  });
})($);